module.exports = __webpack_public_path__ + "static/img/avatar.08803b0d.png";